import { format } from 'date-fns';
import { transformAsCurrency } from '~/utils/functions';

type Params = {
  dataForm: any;
  flags: any;
  formProduto: any;
  mainLoja: any;
  selectedLoja: any;
  lojas: any;
  produtoGradeDivisao: any;
  itemsAbaGrade: any[];
  masterDetail: any;
  isGtinplu: boolean;
  isUpdate: boolean;
};

export function buildPayload({
  dataForm,
  flags,
  formProduto,
  mainLoja,
  selectedLoja,
  lojas,
  produtoGradeDivisao,
  itemsAbaGrade,
  masterDetail,
  isGtinplu,
  isUpdate,
}: Params) {
  const cod_anp =
    dataForm.cod_anp?.value === '' && !dataForm.cod_anp?.value
      ? null
      : dataForm.cod_anp?.value;

  const cod_gtin = `${'0'.repeat(13)}${Number(dataForm.cod_produto)}`.slice(
    -13,
  );

  const dataGtins = formProduto.Gtins.gtins.map((item: any) => ({
    cod_gtin: item.cod_gtin.value,
  }));

  let dataAssociados: any[] = [];

  const associados =
    dataForm.tipo_associado === 1
      ? dataForm.associados_pai
      : dataForm.associados_filho;

  if (associados) {
    dataAssociados = associados.map((item: any) => ({
      cod_produto: item.cod_produto,
      per_desc_assoc: transformAsCurrency(item.per_desc_assoc),
      per_acresc_assoc: transformAsCurrency(item.per_acresc_assoc),
      flg_atual_vda_assoc: item.flg_atual_vda_assoc,
    }));
  }

  let dataProdutoFornecedor: any[] = [];

  if (dataForm.fornecedores) {
    dataProdutoFornecedor = dataForm.fornecedores.map((item: any) => {
      const dataUnidades = (item.Unidades?.unidades || []).map(
        (unidade: any) => ({
          des_referencia: unidade.des_referencia,
          qtd_embalagem_compra: unidade.qtd_embalagem_compra,
          des_unidade_compra: unidade.des_unidade_compra || null,
          des_embalagem: unidade.des_embalagem || '',
        }),
      );

      return {
        cod_fornecedor: item.cod_fornecedor.value,
        flg_principal: item.flg_principal.value,
        flg_fabricante: item.flg_fabricante.value,
        unidades: dataUnidades,
      };
    });
  }

  let codReceita = null;
  if (dataForm?.cod_receita?.value) {
    codReceita =
      dataForm?.cod_receita?.value === -1 ? null : dataForm.cod_receita.value;
  }

  const codNcmValue =
    typeof dataForm.cod_ncm === 'number'
      ? dataForm.cod_ncm
      : dataForm.cod_ncm?.value;

  const dataProdutoLoja = {
    flg_fora_linha: flags.flg_fora_linha,
    tipo_associado: dataForm.tipo_associado,
    cod_ncm: codNcmValue,
    tecla_balanca: dataForm.tecla_balanca,
    qtd_etiqueta: dataForm.qtd_etiqueta || 0,
    num_lote_rast: dataForm.num_lote_rast,
    qtd_lote_rast: dataForm.qtd_lote_rast,
    cod_agreg_rast: dataForm.cod_agreg_rast || undefined,
    dta_fabricacao_rast:
      dataForm.dta_fabricacao_rast === ''
        ? format(new Date(), 'yyyy-MM-dd')
        : dataForm.dta_fabricacao_rast,
    cod_receita: codReceita,
    cod_tara: dataForm.cod_tara?.value === -1 ? null : dataForm.cod_tara.value,
    flg_vale_gas: flags.flg_vale_gas,
    flg_lib_fiscal: flags.flg_lib_fiscal,
    cod_vasilhame: dataForm.cod_vasilhame?.value,
    flg_veda_cred: flags.flg_veda_cred,
    flg_veda_cred_lim: flags.flg_veda_cred_lim,
    per_veda_cred_lim: String(dataForm.per_veda_cred_lim)
      ? String(dataForm.per_veda_cred_lim).replace(',', '.')
      : 0,
    associados: dataAssociados,
    flg_atualiza_custo_decomp: flags.flg_atualiza_custo_decomp,
    cod_ibs_cbs: dataForm?.cod_ibs_cbs?.value ?? null,
    qtd_est_minimo: dataForm.qtd_est_minimo || 0,
  };

  let dataEmbalagens: any[] = [];

  if (dataForm.embalagens && dataForm.embalagens.length > 0) {
    dataEmbalagens = dataForm.embalagens.map((item: any) => ({
      val_peso_bruto: item.val_peso_bruto.value,
      val_peso_emb: item.val_peso_emb.value,
      qtd_embalagem: item.qtd_embalagem.value,
      cod_gtin: isGtinplu ? cod_gtin : item.cod_gtin.value.value,
      des_unidade: item.des_unidade.value.value,
      qtd_divisor_preco: item.qtd_divisor_preco.value,
      des_unidade_medida_preco:
        item.des_unidade_medida_preco?.value?.value?.trim() || {
          label: 'UN - Unidade',
          value: 'UN',
        },
    }));
  }

  const des_unidade_venda = dataForm?.des_unidade_venda?.value?.trim() || null;

  const formData = {
    lojas: [mainLoja.cod_loja],
    duplica_para_lojas: dataForm.duplica_para_lojas,
    cod_produto: dataForm.cod_produto,
    cod_gtin_principal: isGtinplu
      ? cod_gtin
      : formProduto.cod_gtin_principal.value,
    des_produto: dataForm?.des_produto?.trim(),
    des_reduzida: dataForm?.des_reduzida?.trim(),
    qtd_embalagem_compra: dataForm.qtd_embalagem_compra,
    des_unidade_compra: dataForm?.des_unidade_compra?.value?.trim() || null,
    qtd_embalagem_venda: dataForm.qtd_embalagem_venda,
    des_unidade_venda,
    val_peso: transformAsCurrency(dataForm.val_peso),
    val_peso_emb: transformAsCurrency(dataForm.val_peso_emb),
    val_peso_bruto: transformAsCurrency(dataForm.val_peso_bruto),
    flg_alcoolico: flags.flg_alcoolico,
    cod_departamento: dataForm.cod_departamento.value,
    cod_similar:
      dataForm.cod_similar?.value === -1 ? null : dataForm.cod_similar?.value,
    cod_marca:
      dataForm.cod_marca?.value === -1 ? null : dataForm.cod_marca?.value,
    flg_envia_balanca: flags.flg_envia_balanca,
    flg_ipv: flags.flg_ipv,
    qtd_dias_validade: dataForm.qtd_dias_validade,
    flg_envia_pdv: flags.flg_envia_pdv,
    flg_permite_parc: flags.flg_permite_parc,
    tipo_multiplicacao: dataForm?.tipo_multiplicacao?.value,
    flg_rastreavel: flags.flg_rastreavel,
    cod_info_nutricional:
      dataForm.cod_info_nutricional?.value === -1
        ? null
        : dataForm.cod_info_nutricional.value,
    flg_nao_pis_cofins: flags.flg_nao_pis_cofins,
    flg_lei_complementar_224: Boolean(flags.flg_lei_complementar_224),
    des_tab_sped: dataForm.des_sped,
    cod_tab_sped: dataForm.cod_sped,
    cod_cred_pres: !dataForm.entrada_pis_cofins
      ? null
      : dataForm.entrada_pis_cofins.value,
    tipo_nao_pis_cofins: flags.flg_nao_pis_cofins
      ? dataForm?.tipo_nao_pis_cofins?.value
      : -1,
    qtd_divisor_preco: dataForm.qtd_divisor_preco,
    ipi_tipo: dataForm.ipi_tipo.value,
    ipi_val:
      dataForm.ipi_tipo.value === -1
        ? 0
        : Number(String(dataForm.ipi_val).replace(',', '.')),
    des_unidade_medida_preco: dataForm.des_unidade_medida_preco.value ?? {
      label: 'UN - Unidade',
      value: 'UN',
    },
    produtoLoja: dataProdutoLoja,
    gtins: isGtinplu ? [{ cod_gtin }] : dataGtins,
    embalagens: dataEmbalagens,
    fornecedores: dataProdutoFornecedor,
    tipo_movimentacao: dataForm.tipo_movimentacao.value,
    per_perda:
      dataForm.per_perda === ''
        ? 0
        : String(dataForm.per_perda).replace(',', '.'),
    flg_explosao_compra: flags.flg_explosao_compra,
    flg_explosao_venda: flags.flg_explosao_venda,
    cod_tipo_item: dataForm.cod_tipo_item.value,
    cod_id_ctb: dataForm.cod_id_ctb.value,
    produtoGradeDivisao,
    itemsAbaGrade,
    cod_anp,
    des_unidade_tributavel: dataForm?.des_unidade_tributavel,
    per_glp: String(dataForm?.per_glp).replace(',', '.') || 0.0,
    per_gnn: String(dataForm?.per_gnn).replace(',', '.') || 0.0,
    per_gni: String(dataForm?.per_gni).replace(',', '.') || 0.0,
    val_part_glp: transformAsCurrency(dataForm?.val_partida) || 0.0,
    flg_consumo_monitorado: flags.flg_consumo_monitorado,
    masterDetail,
  };

  // ===== LOJAS (IDÊNTICO AO ORIGINAL)
  if (selectedLoja) {
    if (typeof selectedLoja === 'number') {
      formData.lojas = [selectedLoja];
    } else {
      formData.lojas = selectedLoja;
    }
  }

  if (!isUpdate) {
    if (lojas) {
      if (typeof lojas === 'number') {
        formData.lojas = [lojas];
      } else {
        formData.lojas = lojas;
      }
    }
  }

  return formData;
}
